














import { Component, Vue } from 'vue-property-decorator'
import MessageBus from '../utils/buses/MessageBus'

@Component
export default class Message extends Vue {
    private show: boolean = false
    private type: String | null = 'success'
    private message: String = ''
    private key: String | null = null
    private timeout: number | null = null
    created () {
      MessageBus.$on('message-sent', this.showMessage)
    }
    beforeDestroy () {
      // remove event listener to avoid memory leaks
      MessageBus.$off('message-sent', this.showMessage)
    }
    showMessage (message: string, type: string, key: string) {
      this.message = message
      this.type = type
      this.key = key
      this.show = true
      if (this.timeout) {
        clearTimeout(this.timeout)
      }
      // clear message after 8 seconds
      this.timeout = setTimeout(() => {
        this.show = false
      }, 8000)
    }
    clearMessage () {
      this.message = ''
      this.type = ''
    }
}
